module.exports = __webpack_public_path__ + "static/media/14UNEP14.466c7d92.jpg";